import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { criarQueryClient } from '@/lib/query-client';
import '@/styles/globals.css';

function isKnownExternalMessageBridgeError(reason: unknown): boolean {
  const message =
    typeof reason === 'string'
      ? reason
      : reason instanceof Error
        ? reason.message
        : typeof reason === 'object' && reason !== null && 'message' in reason
          ? String(reason.message)
          : '';

  return message.includes('No Listener: tabs:outgoing.message.ready');
}

window.addEventListener('unhandledrejection', event => {
  if (!isKnownExternalMessageBridgeError(event.reason)) {
    return;
  }

  event.preventDefault();
});

// Cria o cliente do React Query
const queryClient = criarQueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter
        future={{
          v7_relativeSplatPath: true,
        }}
      >
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
